// extracted by mini-css-extract-plugin
export default {"chatArea":"dashboard_chatArea__VqMdB","contactElements":"dashboard_contactElements__6vZUz","chatElements":"dashboard_chatElements__r9H80","start":"dashboard_start__q1SKe"};